import React, { useState } from 'react';
import cn from 'classnames';
import {
  Heading,
  HeadingEnum,
  BoldEnum,
  ContactForm,
  CorporateContent,
  Text,
  TextEnum,
  TextColorEnum,
} from '@desquared/wave-components-library';
import { setFields } from '@/utils/corporateUtils';
import { sendMail } from '../../api/internal/mailer';
import LoaderStore from '../../store/loader';
import styles from './ContactFormPage.module.css';
import { useTranslations } from 'next-intl';

export default function ContactFormPage(props) {
  const contactFormId = props.form.data[props.index].content.contact_form.id;
  const matchingContactForm = props.form.included.contact_form.find(form => form.id === contactFormId);
  const form = matchingContactForm.content;
  const [text, setText] = useState('');
  const t = useTranslations();
  const [inputText, setInputText] = useState(t('common.form.upload'));
  const [successCode, setSuccessCode] = useState('unknown');

  const [uploadedFile, setUploadedFile] = useState();
  function onUploadFile(e) {
    const file = e.target.files[0];

    setInputText(file?.name || '');
    setUploadedFile(file);
  }
  async function onSubmit(formFields) {
    LoaderStore.addEvent('SEND_EMAIL');
    // e.preventDefault();

    const formParams = new FormData();

    Object.entries(formFields).forEach(([key, value]) => {
      if (value) {
        if (key === 'Theme' || key === 'Θέμα') {
          const newKey = process.env.contactData[props.locale].options.find(el => el.title === value);
          if (newKey) {
            formParams.append('contactCase', newKey.enum);
          }
        } else if (key === 'comment') {
          formParams.append('message', value);
        } else {
          const newKey = process.env.contactData[props.locale].fields.find(el => el.title === key);
          if (newKey) {
            formParams.append(newKey.enum, value);
          }
        }
      }
    });

    if (!formParams.has('contactCase'))
      formParams.append('contactCase', process.env.contactData[props.locale].options[0].enum);
    if (uploadedFile) {
      formParams.append('attachments', uploadedFile, uploadedFile.name);
    }
    if (_.isEmpty(formFields)) {
      LoaderStore.removeEvent('SEND_EMAIL');
      setText(t('common.form.fields_error'));
      setSuccessCode('error');
      return;
    }

    const { error } = await sendMail(formParams);
    if (error) {
      LoaderStore.removeEvent('SEND_EMAIL');
      setText(t('common.form.generic_error'));
      setSuccessCode('error');
      return;
    }

    LoaderStore.removeEvent('SEND_EMAIL');
    setText(t('common.form.success'));
    setSuccessCode('success');
  }
  return (
    <section className={cn(styles.layout)}>
      <Heading type={HeadingEnum.HeadingM} bold={BoldEnum.Bold}>
        {props.form.data[props.index].content.title}
      </Heading>

      {props.form.included?.corporate_content?.length > 0 &&
        props.form.included?.corporate_content[0]?.content?.title && (
          <CorporateContent
            img={props.form.included?.corporate_content[0]?.content?.image?.url ?? ''}
            imgTitle={props.form.included?.corporate_content[0]?.content?.title}
            buttonText={props.form.included?.corporate_content[0]?.content?.buttonText}
          >
            {props.form.included?.corporate_content[0]?.content?.description && (
              <div
                dangerouslySetInnerHTML={{ __html: props.form.included?.corporate_content[0]?.content?.description }}
              ></div>
            )}
          </CorporateContent>
        )}

      <ContactForm
        fields={setFields(props.locale, form.dropdown_title)}
        title={form.title ?? ''}
        description={form?.description ?? ''}
        buttonText={form?.button_text ?? ''}
        checkboxText={form?.checkbox_text ?? ''}
        img={form?.image?.url ?? ''}
        textAreaTitle={form?.message ?? ''}
        onClick={onSubmit}
        successCode={successCode}
        successText={text}
        errorText={text}
      >
        {form?.has_upload && (
          <div className={styles.fileUpload}>
            <label htmlFor="cv" className={styles.text}>
              <Text type={TextEnum.Body} bold={BoldEnum.Bold} color={TextColorEnum.OnSurfaceHighEmphasis}>
                {inputText}
              </Text>
              <Text type={TextEnum.Assistive} color={TextColorEnum.OnSurfaceLowEmphasis}>
                DOC, DOCX, PDF (2MB)
              </Text>
            </label>
            <input
              type="file"
              name="cv"
              id="cv"
              accept="application/pdf,application/msword,
            application/vnd.openxmlformats-officedocument.wordprocessingml.document,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              className={styles.inputUpload}
              onChange={onUploadFile}
            />
          </div>
        )}
      </ContactForm>
    </section>
  );
}
